import { useEffect } from "react";
import "@/styles/studio.css";

export const useStudioTheme = (on) => useEffect(() => {
  document.documentElement.classList.toggle("theme-studio", on);
  return () => document.documentElement.classList.remove("theme-studio");
}, [on]);

export const resolvePublicTheme = (params, theme) => {
  const p = params.get("preview");
  return p === "studio" || p === "classic" ? p : theme || "classic";
};
